export const removeNbsp = (text: string) => text.trim().replace(/&nbsp;/g, '');
